import React from 'react';
import Menu2 from '../../components/MenuElements/Menu2';
import Takeout from '../../components/MenuElements/Takeout';
import PageHeader from '../Shared/PageHeader';

const Menu02 = () => {
    return (
        <div>
            <PageHeader title="Our Menu"></PageHeader>
            <Menu2></Menu2>
            <Takeout></Takeout>
        </div>
    );
};

export default Menu02;